<style lang="scss" scoped>
.card-item {
  margin: -10px -5px;
}
</style>
<template>
  <div>
    <jijiu-page-title title="接收" :prefix="prefix"></jijiu-page-title>
    <faqi-jieshou-form
        aspect-user="accept"
        class="mt10"
        @sub="submit"
    ></faqi-jieshou-form>
    <el-radio-group size="mini" v-model="status" class="mt10">
      <el-radio-button
          v-for="(item, idx) in statusArr"
          :label="item.id"
          :key="idx"
      >{{ item.name }}
      </el-radio-button>
    </el-radio-group>
    <div class="list flex mt10 wrap" v-loading="appShowLoading">
      <el-card
          class="flex0"
          :style="mixinCardStyle"
          v-for="(item, idx) in list"
          :key="idx"
          :class="{ ml15: idx % 3 > 0, mt15: idx > 2 }"
      >
        <router-link
            tag="div"
            :to="{
            path: '/staff/detail',
            query: { id: item.id, aspectUser: 'accept',hasEmergencyReferral }
          }"
            class="card-item pointer"
        >
          <h3 class="flex aic">
            <span class="fs14">{{ item.patName }}</span>
            <span class="fs14 ml10">{{ item.patGender | sexFilter }}</span>
            <span class="fs14 ml10">{{ item.patAge }}岁</span>
            <div class="flex1 ml10">
              <el-tag type="warning">{{ getDispatchingCarDesc(item) }}</el-tag>
            </div>
            <span class="fs14 color_main">{{ item.referralStatusDesc }}</span>
          </h3>
          <div class="fs18 mt10">
            {{ item.initHosName }} → {{ item.hopeHosName }}
          </div>
          <div class="mt10 color_777 flex fs12">
            <span class="flex1">编号:{{ item.emergencyyReferralOrderNo }}</span>
            <span>
                            {{ item.createTime | timeFilter("YYYY-MM-DD HH:mm:ss") }}
              申请
                        </span>
          </div>
        </router-link>
      </el-card>
    </div>
    <div class="mt10">
      <el-pagination
          background
          :page-size="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          @current-change="this.getList"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import JijiuPageTitle from "../components/jijiu-page-title";
import FaqiJieshouForm from "../components/faqi-jieshou-form";
import {ContentWidthMixin} from "../../../common/lib/mixins/contentWidth";
import {ASPECTUSER, STAFF_ORDER_STATUS} from "../config";
import {staffService} from "../service/staff";
import {sexFilter, timeFilter} from "../../../common/lib/filters";
import {DispatchingCarMixin, hasEmergencyReferralMixin} from "../mixins";

export default {
  name: "jijiu-jieshou",
  filters: {sexFilter, timeFilter},
  components: {FaqiJieshouForm, JijiuPageTitle},
  mixins: [ContentWidthMixin, DispatchingCarMixin, hasEmergencyReferralMixin],
  data() {
    const statusArr = [].concat(STAFF_ORDER_STATUS);
    //statusArr[0].name = "待处理";
    return {
      aspectUser: ASPECTUSER.accept,
      page: {
        pageNum: 1,
        pageSize: 9
      },
      list: [],
      status: "NEED_EXAMINE",
      statusArr
    };
  },
  computed: {},
  created() {
    this.setHasEmergencyReferral();
    this.setStatusArray();
    this.count();
    this.getList();
  },
  watch: {
    status() {
      this.getList();
    }
  },
  methods: {
    submit(form) {
      this.form = form;
      this.getList();
    },
    async count() {
      for (let i = 0; i < this.statusArr.length; i++) {
        const status = this.statusArr[i];
        const {page} = await staffService.listOrder({
          aspectUser: ASPECTUSER.accept,
          statusList: status.id.split(','),
          hasEmergencyReferral: this.hasEmergencyReferral
        });
        const oldName = status.oldName || status.name;
        this.statusArr.splice(i, 1, {
          ...status,
          oldName: oldName,
          total: page.total,
          name: oldName + `(${page.total || 0})`
        });
      }
    },
    updateCount() {
      const {page, status, statusArr} = this;
      const idx = statusArr.findIndex(r => r.id === status);
      statusArr.splice(idx, 1, {
        ...statusArr[idx],
        total: page.total,
        name: statusArr[idx].oldName + `(${page.total})`
      });
    },
    async getList(p) {
      const {pageSize, pageNum} = this.page;
      const {list, page} = await staffService.listOrder({
        ...this.form,
        aspectUser: ASPECTUSER.accept,
        statusList: this.status.split(','),
        pageNo: (p && parseInt(p)) || pageNum || 1,
        pageSize: pageSize,
        hasEmergencyReferral: this.hasEmergencyReferral
      });
      this.list = list;
      this.page = page;
      this.$nextTick(() => {
        this.mixinInitContentWidth();
      });
    }
  }
};
</script>
